/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createGroup.defs'
export { main as default } from './createGroup.defs'
